/**
 * Os formatos que o leitor procura, por caso de uso.
 *
 * **Em arquivo próprio, e não dentro de `Scanner.tsx`:** um módulo que exporta
 * componente **e** constante quebra o Fast Refresh, e o
 * `react-refresh/only-export-components` reprova — a mesma razão que já separou
 * `finance-context.ts` do provider.
 *
 * A lista é curta de propósito. Pedir "todos os formatos" faria o decodificador
 * procurar Aztec e DataMatrix em cada quadro de um cupom de mercado, o que custa
 * tempo por nada — e aumenta a chance de ler um código que não é o que a pessoa
 * apontou.
 */
export const FORMATOS = {
  /** Código de barras de embalagem: EAN e UPC. */
  produto: ['EAN13', 'EAN8', 'UPCA', 'UPCE'],
  /** O QR do cupom fiscal. */
  qr: ['QRCode'],
} as const

export type CasoDeUso = keyof typeof FORMATOS
